import React from "react";
import { connect } from 'react-redux';
import styled from "styled-components";
import { withI18n } from "react-i18next";
import { RouteComponentProps, withRouter } from 'react-router-dom';
// @ts-ignore
import { CWBModal, moment } from "cwb-react";
import { IKioskSessionsDto } from "../../shared/dto/IKioskDto";


const LocationModal = ({ className, t, buttons, location, setLocationEnabledModal }: any) => (
  <StyledModal
    className={`${className} cwb-modal`}
    title={t("Audition Location")}
    hideModal={() => setLocationEnabledModal(false)}
    isOpen={true}
    buttons={
      buttons || []
    }
  >
    <div>
      <section>
        <Title>
          {location}
        </Title>
        <form></form>
      </section>
    </div>
  </StyledModal>
);

const StyledModal = styled(CWBModal)`
  width: 100%;
  max-width: 600px !important;
  margin: 0 auto;

  &.create-role-modal {
    max-width: 450px;

    .modal-buttons {
      justify-content: space-around !important;
    }
  }

  .modal-dropdown {
    min-width: 200px;
    max-width: 200px;
    .cwb-dropdown__menu {
      .cwb-dropdown__option {
        min-width: 185px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .modal-content {
    width: 100%;
  }

  .modal-body {
    margin-bottom: 32px;
    padding-bottom: 16px;
    text-align: left !important;
  }

  .modal-buttons {
    justify-content: space-between !important;
  }

  .close-modal {
    right: 20px;

    &:before {
      color: #8395a7;
      font-size: 16px;
    }
  }

  .cwb-dropdown-wrapper {
    .cwb-dropdown__menu-list {
      text-align: left;
    }
  }
`;

const Title = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
  margin-top: 20px;
`;

const StyledButton = styled.button`
  min-width: 80px;

  &:first-child {
    margin-right: 16px;
  }
`;


interface StateProps {
  location : string
}

const mapStateToProps = (state: any) => ({
  location: state.kiosk.showLocationEnabledModal && 
            state.kiosk.showLocationEnabledModal.show && state.kiosk.showLocationEnabledModal.scheduleId && 
            state.kiosk.sessions && state.kiosk.sessions.length ? 
            (state.kiosk.sessions.find((a : IKioskSessionsDto) => a.scheduleId == state.kiosk.showLocationEnabledModal.scheduleId).location) :
            (state.kiosk.sessionInfo && state.kiosk.sessionInfo.location)
});

interface DispatchProps {
  setLocationEnabledModal: (show: boolean) => any;
}

const mapDispatchToProps = (dispatch: any) => ({
  setLocationEnabledModal: dispatch.kiosk.setLocationEnabledModal
});

export default withI18n()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationModal)));
